module.exports = __webpack_public_path__ + "img/kuang4.862824a8.png";